import React from 'react';
import './ProductToggle.css';

/**
 * ProductToggle Component
 * Toggle between products (Customer Self-Service / Business Interface)
 * 
 * @param {string} activeTab - Currently active tab ('customer-self-service' or 'business-interface')
 * @param {function} onTabChange - Callback when tab changes: (tab: string) => void
 * @param {object} labels - Labels object {customerSelfService: string, businessInterface: string}
 * @param {string} className - Additional CSS classes
 */
const ProductToggle = ({
  activeTab,
  onTabChange,
  labels = {
    customerSelfService: 'Customer Self-Service',
    businessInterface: 'Business Interface'
  },
  className = ''
}) => {
  const handleTabClick = (tab) => {
    if (onTabChange) {
      onTabChange(tab);
    }
  };

  return (
    <div className={`product-toggle-container ${className}`}>
      <div className="product-toggle">
        <button 
          type="button"
          className={`toggle-button ${activeTab === 'customer-self-service' ? 'active' : ''}`}
          onClick={() => handleTabClick('customer-self-service')}
          aria-pressed={activeTab === 'customer-self-service'}
          aria-label={labels.customerSelfService}
        >
          {labels.customerSelfService}
        </button>
        <button 
          type="button"
          className={`toggle-button ${activeTab === 'business-interface' ? 'active' : ''}`}
          onClick={() => handleTabClick('business-interface')}
          aria-pressed={activeTab === 'business-interface'}
          aria-label={labels.businessInterface}
        >
          {labels.businessInterface}
        </button>
      </div>
    </div>
  );
};

export default ProductToggle;


